import { Switch } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useAgencyInfo } from "context/agency";
import { useAppServices } from "hook/services";
import ReactSelect from "react-select";
import SoftTypography from "components/SoftTypography";
import toast from "react-hot-toast";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

const MultistepFormWizard = ({ onClose, handleRefresh, data }) => {
  const [step, setStep] = useState(1);
  const [loader, setLoader] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [agency] = useAgencyInfo();
  const AppService = useAppServices();
  const [promplabels, setpromplabels] = useState([]);
  // const [isFreeSaas, setIsFreeSaas] = useState(false);
  const [addTagModel, setAddTagModel] = useState(false);
  const [addCategoryModel, setAddCategoryModel] = useState(false);
  const [categoryFormData, setCategoryFormData] = useState([]);
  const [googleMap, setgoogleMap] = useState(false);
  const [reviewsCheck, setReviewsCheck] = useState(false);
  const [BusinessHourCheck, setBusinessHourCheck] = useState(false);
  const [videoUploadCheck, setVideoUploadCheck] = useState(false);
  const [imageSliderCheck, setImageSliderCheck] = useState(false);
  const [CompanyLogoCheck, setCompanyLogoCheck] = useState(false);
  const [ScheduledDayCheck, setScheduledDayCheck] = useState(false);
  const [VideoCheck, setVideoCheck] = useState(false);
  const [extraLinksCheck, setextraLinksCheck] = useState(false);
  const [ShortcodeCheck, setShortcodeCheck] = useState(false);
  const [SocialmediaCheck, setSocialmediaCheck] = useState(false);
  const [customBlogsCheck, setcustomBlogsCheck] = useState(false);
  const [promoVideoCheck, setpromoVideoCheck] = useState(false);
  const [gmbseoCheck, setgmbseoCheck] = useState(false);
  const [gmbprofileCheck, setgmbprofileCheck] = useState(false);
  const [addonsData, setAddonsData] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [editValue, setEditValue] = useState("");

  const moveFeature = (fromIndex, toIndex) => {
    if (toIndex < 0 || toIndex >= formData.features.length) return;

    const updatedFeatures = [...formData.features];
    const [movedItem] = updatedFeatures.splice(fromIndex, 1);
    updatedFeatures.splice(toIndex, 0, movedItem);

    setFormData((prev) => ({
      ...prev,
      features: updatedFeatures,
    }));
  };

  const googleMapchanger = () => {
    setgoogleMap(!googleMap);
  };
  const reviewsChanger = () => {
    setReviewsCheck(!reviewsCheck);
  };

  const BusinessHourChanger = () => {
    setBusinessHourCheck(!BusinessHourCheck);
  };

  const videoUploadChanger = () => {
    setVideoUploadCheck(!videoUploadCheck);
  };

  const imageSliderChanger = () => {
    setImageSliderCheck(!imageSliderCheck);
  };

  // sdg

  const companyLogo = () => {
    setCompanyLogoCheck(!CompanyLogoCheck);
  };
  const ScheduledDay = () => {
    setScheduledDayCheck(!ScheduledDayCheck);
  };
  const VideoChanger = () => {
    setVideoCheck(!VideoCheck);
  };
  const ExtraLinksChanger = () => {
    setextraLinksCheck(!extraLinksCheck);
  };
  const ShortcodeChanger = () => {
    setShortcodeCheck(!ShortcodeCheck);
  };
  const socialMediaChanger = () => {
    setSocialmediaCheck(!SocialmediaCheck);
  };
  const customBlogsChanger = () => {
    setcustomBlogsCheck(!customBlogsCheck);
  };
  const promoVideoChanger = () => {
    setpromoVideoCheck(!promoVideoCheck);
  };
  const gmbseoChanger = () => {
    setgmbseoCheck(!gmbseoCheck);
  };
  const gmbprofileChanger = () => {
    setgmbprofileCheck(!gmbprofileCheck);
  };

  const [hasFreeSaasPlan, setHasFreeSaasPlan] = useState(false);
  const [formData, setFormData] = useState({
    plan: { planName: "", description: "" },
    // is_free_saas: false,
    category: { categorySelected: null, categoryOptions: null },
    pricing: { monthly_price: null, yearly_price: null, user_limit: 0, contact_limit: 0 },
    apps: { snapshotselected: [], promptlabel_ids: [] },
    trial_and_credit: { active_trile_period: false, add_credit: false, days: 0, credit_amount: 0 },
    rebilling: { ai_active: false, markupmargin: 1 },
    agency: { id: agency._id }, // Replace with your actual `agency._id`
    features: [
      { name: "Address", showName: "Address", value: false },
      { name: "Phone", showName: "Phone", value: false },
      { name: "Website", showName: "Website", value: false },
      { name: "Featured Image", showName: "Profile Image", value: false },
      { name: "Company Logo", showName: "Cover Image", value: false },
      { name: "Email Address", showName: "Email Address", value: false },
      { name: "Social Media", showName: "Social Media", value: false },
      { name: "Business Description", showName: "Business Description", value: false },
      {
        name: "Business Hour Configurations",
        showName: "Business Hour Configurations",
        value: false,
      },
      { name: "Additional Details", showName: "Additional Images", value: false },
      { name: "Extra Links", showName: "Extra Links", value: false },

      { name: "Blogs", showName: "Blogs", value: false },
      { name: "Events", showName: "Events", value: false },
      { name: "Jobs", showName: "Jobs", value: false },
      { name: "News Feeds", showName: "News Feeds", value: false },
      { name: "Teams", showName: "Teams", value: false },
      { name: "Reviews", showName: "Site Reviews", value: false },
      { name: "Video", showName: "Video Embed", value: false },
      { name: "Google Place Images", showName: "Google Place Images", value: false },
      { name: "Google Reviews", showName: "Google Reviews", value: false },

      { name: "Google Map Configuration", showName: "Google Map Configuration", value: false },

      ...addonsData.map((data) => ({ _id: data._id, name: data.name, value: false })),
    ],
    external: false,
    monthly_url: "",
    yearly_url: "",
    currency: "usd",
    currency_symbol: "$",
  });

  const handleRenameFeature = (index, newName) => {
    setFormData((prev) => {
      const updated = [...prev.features];

      // prevent rename for addons
      if (updated[index]._id) return prev;

      updated[index].showName = newName;

      return { ...prev, features: updated };
    });
  };

  useEffect(() => {
    async function fetchData() {
      const response = await AppService.saas.fetch_addons({ query: `agency_id=${agency?._id}` });
      const addons = response?.response?.data || [];
      setAddonsData(addons);
      setFormData((prevData) => ({
        ...prevData,
        features: [
          ...prevData.features,
          ...addons.map((addon) => ({ _id: addon._id, name: addon.name, value: false })),
        ],
      }));
    }
    fetchData();
  }, []);

  const updateFeatureInFormData = (index) => {
    setFormData((prevData) => {
      const newFeatures = [...prevData.features];
      newFeatures[index].value = !newFeatures[index].value;
      return { ...prevData, features: newFeatures };
    });
  };

  const [errors, setErrors] = useState({});
  const validateStep1 = () => {
    const step1Errors = {};
    if (!formData.plan.planName.trim()) {
      step1Errors.planName = "Plan Name is required";
    }
    if (!formData.plan.description.trim()) {
      step1Errors.description = "Description is required";
    }
    if (formData.external && formData.pricing.monthly_price && !formData.monthly_url.trim()) {
      step1Errors.monthly_url = "Monthly url is required";
    }
    if (formData.external && formData.pricing.yearly_price && !formData.yearly_url.trim()) {
      step1Errors.yearly_url = "Yearly url is required";
    }
    setErrors(step1Errors);
    return Object.keys(step1Errors).length === 0;
  };
  const handleNext = () => {
    if (step === 1 && validateStep1()) {
      setStep(step + 1);
    } else if (step === 2) {
      setStep(step + 1);
    } else if (step === 3) {
      setStep(step + 1);
    } else if (step === 4) {
      setStep(step + 1);
    } else if (step === 5) {
      setStep(step + 1);
    } else if (step === 6) {
      setStep(step + 1);
    }
  };

  const handleCustomTab = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  const handlePrevious = () => {
    setStep(step - 1);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoader(true);

    try {
      const payload = { ...formData };

      // Check if user has free plan and no pricing is provided
      const isFreePlan =
        hasFreeSaasPlan &&
        (!formData.pricing.monthly_price || formData.pricing.monthly_price === 0) &&
        (!formData.pricing.yearly_price || formData.pricing.yearly_price === 0);

      if (isFreePlan) {
        toast.error("You already have a free plan. Please add a monthly or annual amount!");
        setLoader(false);
        return;
      }

      console.log(payload);

      const { response } = await AppService.saas.createSaas({ payload });

      if (response?.success) {
        onClose();
        handleRefresh();
        toast.success(response.message);
      } else {
        toast.error(response.message || "Something went wrong");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("An error occurred during submission.");
    } finally {
      setLoader(false);
    }
  };

  const handleSelectChange_of_Category = (option) => {
    setFormData({
      ...formData,
      category: { ...formData.category, categoryOptions: option.value },
      category: { ...formData.category, categorySelected: option.value },
    });
  };

  const handleToggleChange_toggle_phone_system_reselling = (event) => {
    setFormData({
      ...formData,
      rebilling: { ...formData.rebilling, ai_active: event.target.checked },
    });
  };

  const handleToggleFeature = (index) => {
    setFormData((prevState) => {
      const updatedFeatures = [...prevState.features];
      updatedFeatures[index] = {
        ...updatedFeatures[index],
        value: !updatedFeatures[index].value,
      };
      return { ...prevState, features: updatedFeatures };
    });
  };

  const celenderappchanger = () => {
    setcelenderchanger(!celenderchanger);
    let updatedSnapshotSelected = [...formData.apps.snapshotselected];
    if (!celenderchanger) {
      // If celenderchanger is false, we are about to set it to true, so we push the value
      updatedSnapshotSelected.push("AI Celender App");
    } else {
      // If celenderchanger is true, we are about to set it to false, so we remove the value
      updatedSnapshotSelected = updatedSnapshotSelected.filter(
        (item) => item !== "AI Celender App"
      );
    }
    setFormData({
      ...formData,
      apps: { ...formData.apps, snapshotselected: updatedSnapshotSelected },
    });
  };

  const savedataPromptLabel = async (formData) => {
    const updatedFormData = {
      ...formData,
      agency_id: agency._id,
      type: "agency",
    };
    const payload = updatedFormData;
    //
    const { response } = await AppService.promptslabel.create({
      payload,
      toaster: true,
    });
    if (response) {
      handleclose();
      setAddTagModel(false);
      onLoad();
    }
  };
  const handleclose = () => {
    setAddTagModel(false);
  };
  const handleAddTag = () => {
    setAddTagModel(true);
  };
  const handleAddCategory = () => {
    setAddCategoryModel(true);
  };

  const handleFeatureToggle = (featureName) => {
    setFormData((prevData) => ({
      ...prevData,
      features: prevData.features.map((feature) =>
        feature.name === featureName ? { ...feature, value: !feature.value } : feature
      ),
    }));
  };

  const savecategory = async () => {
    categoryFormData.agency_id = agency._id;
    const payload = categoryFormData;
    console.log(payload);
    const { response } = await AppService.saas.categorypricing({ payload });
    if (response) {
      setAddCategoryModel(false);
      setCategoryFormData([]);
      onLoad();
    }
  };

  const Change_of_currency = (option) => {
    // setCategoryFormData({
    //   ...categoryFormData,
    //   currency: option.value,
    // });

    setFormData({
      ...formData,
      currency: option.value,
      currency_symbol: option.label.split(" ")[0],
    });
  };
  const availableCRNC = [
    { value: "usd", label: "$ USD" },
    { value: "eur", label: "€ Euro" },
    { value: "jpy", label: "¥ Japanese Yen" },
    { value: "gbp", label: "£ British Pound Sterling" },
    { value: "aud", label: "$ Australian Dollar" },
    { value: "cad", label: "$ Canadian Dollar" },
    { value: "chf", label: "Fr Swiss Franc" },
    { value: "cny", label: "¥ Chinese Yuan" },
    { value: "hkd", label: "HK$ Hong Kong Dollar" },
    { value: "nzd", label: "$ New Zealand Dollar" },
    { value: "sek", label: "kr Swedish Krona" },
    { value: "krw", label: "₩ South Korean Won" },
    { value: "sgd", label: "S$ Singapore Dollar" },
    { value: "nok", label: "kr Norwegian Krone" },
    { value: "mxn", label: "$ Mexican Peso" },
    { value: "inr", label: "₹ Indian Rupee" },
    { value: "rub", label: "₽ Russian Ruble" },
    { value: "zar", label: "R South African Rand" },
    { value: "brl", label: "R$ Brazilian Real" },
    { value: "try", label: "₺ Turkish Lira" },
    { value: "idr", label: "Rp Indonesian Rupiah" },
    { value: "thb", label: "฿ Thai Baht" },
    { value: "pln", label: "zł Polish Zloty" },
    { value: "php", label: "₱ Philippine Peso" },
    { value: "czk", label: "Kč Czech Koruna" },
    { value: "myr", label: "RM Malaysian Ringgit" },
    { value: "huf", label: "Ft Hungarian Forint" },
    { value: "isk", label: "kr Icelandic Króna" },
    { value: "hrk", label: "kn Croatian Kuna" },
    { value: "dkk", label: "kr Danish Krone" },
    { value: "ils", label: "₪ Israeli Shekel" },
    { value: "ars", label: "$ Argentine Peso" },
    { value: "clp", label: "$ Chilean Peso" },
    { value: "cop", label: "$ Colombian Peso" },
    { value: "pen", label: "S/. Peruvian Sol" },
    { value: "uah", label: "₴ Ukrainian Hryvnia" },
    { value: "egp", label: "£ Egyptian Pound" },
    { value: "sar", label: "ر.س Saudi Riyal" },
    { value: "aed", label: "د.إ UAE Dirham" },
    { value: "vnd", label: "₫ Vietnamese Dong" },
    { value: "kes", label: "KSh Kenyan Shilling" },
    { value: "ngn", label: "₦ Nigerian Naira" },
    { value: "pkr", label: "₨ Pakistani Rupee" },
    { value: "ghs", label: "₵ Ghanaian Cedi" },
    { value: "ugx", label: "USh Ugandan Shilling" },
    { value: "bdt", label: "৳ Bangladeshi Taka" },
    { value: "qar", label: "ر.ق Qatari Riyal" },
    { value: "lbp", label: "ل.ل Lebanese Pound" },
    { value: "mad", label: "د.م. Moroccan Dirham" },
    { value: "cup", label: "$ Cuban Peso" },
    { value: "crc", label: "₡ Costa Rican Colón" },
    { value: "npr", label: "₨ Nepalese Rupee" },
    { value: "hnl", label: "L Honduran Lempira" },
    { value: "gtq", label: "Q Guatemalan Quetzal" },
    { value: "pab", label: "B/. Panamanian Balboa" },
    { value: "uyu", label: "$U Uruguayan Peso" },
    { value: "bob", label: "Bs. Bolivian Boliviano" },
    { value: "pyg", label: "₲ Paraguayan Guarani" },
    { value: "etb", label: "ብር Ethiopian Birr" },
    { value: "awg", label: "ƒ Aruban Florin" },
    { value: "bsd", label: "$ Bahamian Dollar" },
    { value: "bbd", label: "$ Barbadian Dollar" },
    { value: "bzd", label: "BZ$ Belize Dollar" },
    { value: "bmd", label: "$ Bermudian Dollar" },
    { value: "kyd", label: "$ Cayman Islands Dollar" },
    { value: "fjd", label: "$ Fijian Dollar" },
    { value: "gyd", label: "$ Guyanese Dollar" },
    { value: "jmd", label: "J$ Jamaican Dollar" },
    { value: "lrd", label: "$ Liberian Dollar" },
    { value: "nad", label: "$ Namibian Dollar" },
    { value: "srd", label: "$ Surinamese Dollar" },
    { value: "ttd", label: "TT$ Trinidad and Tobago Dollar" },
    { value: "xcd", label: "$ East Caribbean Dollar" },
    { value: "sbd", label: "$ Solomon Islands Dollar" },
  ];
  const [currencies, setcurrencies] = useState([]);
  useEffect(() => {
    onLoad();
  }, []);
  const onLoad = async () => {
    const { response } = await AppService.saas.fetch_category_pricing({
      query: `agency_id=${agency._id}`,
    });
    if (response) {
      let arryadrop = [];
      let arryadrop1 = [];
      response.data.map((item) => {
        arryadrop.push({ label: item.name, value: item._id });
      });
      response.promptslabel.map((item) => {
        arryadrop1.push({ label: item.name, value: item._id });
      });
      setcurrencies(arryadrop);
      setpromplabels(response.promptslabel);
    }
  };
  const handleInputChange = (event) => {
    const tempSliderValue = event.target.value;
    if (tempSliderValue < 1) {
      return true;
    }
    setFormData({
      ...formData,
      rebilling: { ...formData.rebilling, markupmargin: tempSliderValue },
    });

    const progress = (tempSliderValue / event.target.max) * 100;

    event.target.style.background = `linear-gradient(to right, gray ${progress}%, #ccc ${progress}%)`;
  };

  useEffect(() => {
    if (data && Array.isArray(data)) {
      const freePlanExists = data.some((plan) => plan.is_free_saas === true);
      console.log(freePlanExists, "freePlanExists");
      setHasFreeSaasPlan(freePlanExists);
    }
  }, [data]);

  const switchStyles = {
    container: {
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      width: "60px",
      height: "30px",
      backgroundColor: formData.external ? "#4CAF50" : "#ccc",
      borderRadius: "30px",
      padding: "5px",
      position: "relative",
      transition: "background-color 0.3s",
    },
    circle: {
      height: "20px",
      width: "20px",
      backgroundColor: "#fff",
      borderRadius: "50%",
      position: "absolute",
      top: "5px",
      left: formData.external ? "35px" : "5px",
      transition: "left 0.3s",
    },
  };

  return (
    <>
      <div className="container mt-4">
        <div className="flex justify-center">
          <div className="w-full lg:w-3/4">
            <div className=" bg-white shadow-lg rounded-lg p-6">
              <div>
                <form>
                  {step === 1 && (
                    <>
                      <div className="text-left mb-4">
                        <label htmlFor="planName" className="block mb-1 text-black">
                          Plan Name
                        </label>
                        <input
                          type="text"
                          id="planName"
                          className="form-control-agust w-full"
                          value={formData.plan.planName}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              plan: { ...formData.plan, planName: e.target.value },
                            })
                          }
                        />
                        {errors.planName && (
                          <small className="text-red-500" style={{ fontSize: "14px" }}>
                            {errors.planName}
                          </small>
                        )}
                      </div>
                      <div className="text-left mb-4">
                        <label htmlFor="description" className="block mb-1 text-black">
                          Description
                        </label>
                        <input
                          style={{ width: "100%", border: "1px solid #d8cbcb" }}
                          type="text"
                          id="description"
                          className="form-control-agust   w-full"
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              plan: { ...formData.plan, description: e.target.value },
                            })
                          }
                          value={formData.plan.description}
                        />
                        {errors.description && (
                          <small className="text-red-500" style={{ fontSize: "14px" }}>
                            {errors.description}
                          </small>
                        )}
                      </div>
                      <div className="text-left mb-4">
                        <SoftTypography
                          className="text-black w-100 d-flex justify-content-between"
                          variant="button"
                          sx={{ fontSize: "14px", fontWeight: "500" }}
                          mt={1}
                        >
                          <label className="w-50 new_dezin_label text-black ">Currency</label>
                          {/* <p
                          className="w-50 text-right new_dezin_label text-black cursor-pointer"
                          onClick={handleAddCategory}
                        >
                          + Add Category
                        </p> */}
                        </SoftTypography>

                        {/* <ReactSelect
                        name="category"
                        className="form-input w-full"
                        // defaultValue={{ value: "clothing", label: "Clothing" }}
                        options={currencies}
                        isMultiple={false}
                        onChange={handleSelectChange_of_Category}
                      /> */}

                        <ReactSelect
                          name="category"
                          className="form-input w-full"
                          options={availableCRNC}
                          isMulti={false}
                          onChange={Change_of_currency}
                          menuPortalTarget={document.body} // Render dropdown outside the modal
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Set z-index for visibility
                          }}
                          defaultValue={availableCRNC[0]} // Set default value if needed
                        />
                      </div>

                      {/* {!hasFreeSaasPlan && (
                      <div
                        className="text-left mb-4"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <input
                          type="checkbox"
                          name="isFreeSaas"
                          onChange={handleIsFreeSaas}
                          value={isFreeSaas}
                        />
                        <label
                          htmlFor="email"
                          className="block mb-1 text-black"
                          style={{ marginLeft: "14px" }}
                        >
                          Is it a Free SaaS plan?
                        </label>
                      </div>
                    )} */}

                      {/* {!isFreeSaas && ( */}
                      <div className="d-flex justify-content-between">
                        <div className="text-left mb-4">
                          <label htmlFor="planName" className="block text-black">
                            Monthly Price
                          </label>
                          <input
                            type="number"
                            id="monthly_price"
                            name="monthly_price"
                            className="form-control-agust  w-full"
                            value={formData.pricing.monthly_price}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                pricing: { ...formData.pricing, monthly_price: e.target.value },
                              })
                            }
                          />
                        </div>
                        <div className="mb-4 text-left" style={{ margin: "0px 0px 0px 5px" }}>
                          <label htmlFor="planName" className="text-black">
                            Annual Price
                          </label>
                          <input
                            type="number"
                            id="yearly_price"
                            className="form-control-agust  w-full"
                            name="yearly_price"
                            value={formData.pricing.yearly_price}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                pricing: { ...formData.pricing, yearly_price: e.target.value },
                              })
                            }
                          />
                        </div>
                      </div>

                      {(formData.pricing.monthly_price || formData.pricing.yearly_price) && (
                        <div style={{ marginTop: "10px" }}>
                          <label>External checkout</label>
                          <div
                            onClick={(e) =>
                              setFormData({ ...formData, external: !formData.external })
                            }
                            style={switchStyles.container}
                          >
                            <div style={switchStyles.circle}></div>
                          </div>
                        </div>
                      )}
                      {formData.external && (
                        <>
                          {formData.pricing.monthly_price && (
                            <div className="text-left mb-4">
                              <label htmlFor="description" className="block mb-1 text-black">
                                Monthly Url
                              </label>
                              <input
                                type="text"
                                id="monthly_url"
                                style={{ width: "100%", border: "1px solid #d8cbcb" }}
                                className="form-control-agust   w-full"
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    monthly_url: e.target.value,
                                  })
                                }
                                value={formData.monthly_url}
                                required={formData.external && formData.pricing.monthly_price}
                                placeholder="This is required when toggle is ON"
                              />
                              {errors.monthly_url && (
                                <small className="text-red-500" style={{ fontSize: "14px" }}>
                                  {errors.monthly_url}
                                </small>
                              )}
                            </div>
                          )}
                          {formData.pricing.yearly_price && (
                            <div className="text-left mb-4">
                              <label htmlFor="description" className="block mb-1 text-black">
                                Yearly Url
                              </label>
                              <input
                                type="text"
                                id="yearly_url"
                                style={{ width: "100%", border: "1px solid #d8cbcb" }}
                                className="form-control-agust   w-full"
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    yearly_url: e.target.value,
                                  })
                                }
                                value={formData.yearly_url}
                                required={formData.external && formData.pricing.yearly_price}
                                placeholder="This is required when toggle is ON"
                              />
                              {errors.yearly_url && (
                                <small className="text-red-500" style={{ fontSize: "14px" }}>
                                  {errors.yearly_url}
                                </small>
                              )}
                            </div>
                          )}
                        </>
                      )}
                      {/* )} */}
                      {/* <div className="text-left mb-4" style={{ width: "50%" }}>

                      <label htmlFor="planName" className="block text-black">User Limit</label>
                      <input
                        type="number"
                        id="user_limit"
                        className="form-control-agust  w-full"
                        name="user_limit"
                        value={formData.pricing.user_limit}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            pricing: { ...formData.pricing, user_limit: e.target.value },
                          })
                        }
                      />

                    </div> */}
                    </>
                  )}
                  {step === 2 && (
                    <>
                      <div
                        className="text-left mb-4"
                        style={{ maxHeight: "400px", overflowY: "auto", overflowX: "hidden" }}
                      >
                        <p className=" text-black font-15">
                          {" "}
                          Select the features you’d like to enable for this plan:
                        </p>
                        <div className="d-flex justify-between"></div>
                        {formData.features.map((feature, index) => (
                          <>
                            {/* Arrows */}
                            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                              <div style={{ display: "flex", flexDirection: "column" }}>
                                <button
                                  type="button"
                                  disabled={index === 0}
                                  onClick={() => moveFeature(index, index - 1)}
                                  className="text-gray-500 hover:text-black"
                                  style={{
                                    padding: "2px",
                                    background: "transparent",
                                    border: "none",
                                    cursor: "pointer",
                                  }}
                                >
                                  <IoIosArrowUp />
                                </button>
                                <button
                                  type="button"
                                  disabled={index === formData.features.length - 1}
                                  onClick={() => moveFeature(index, index + 1)}
                                  className="text-gray-500 hover:text-black"
                                  style={{
                                    padding: "2px",
                                    background: "transparent",
                                    border: "none",
                                    cursor: "pointer",
                                  }}
                                >
                                  <IoIosArrowDown />
                                </button>
                              </div>
                              <div
                                key={index}
                                className="d-flex justify-between align-items-center card_agust_row"
                                style={{ marginBottom: "14px", width: "100%" }}
                              >
                                <div
                                  className="d-flex align-items-center gap-3"
                                  style={{ maxWidth: "340px" }}
                                >
                                  {/* Feature Name */}
                                  {/* <p className="font-16 text-black mb-0"> */}
                                  <p className="font-16 text-black mb-0">
                                    {feature?.showName ? `${feature?.showName}` : `${feature?.name}`} ({feature?.name == "Featured Image"
                                        ? "Profile Image"
                                        : feature?.name == "Company Logo"
                                        ? "Cover Image"
                                        : feature?.name === "Reviews"
                                        ? "Site Reviews "
                                        : feature?.name == "Video"
                                        ? "Video Embed"
                                        : feature?.name == "Additional Details"
                                        ? "Additional Images "
                                        : feature?.name})
                                  </p>

                                  {!feature._id && (
                                    <button
                                      type="button"
                                      onClick={() => {
                                        setEditIndex(index);
                                        setEditValue(feature.showName || feature.name);
                                      }}
                                      style={{
                                        background: "transparent",
                                        border: "none",
                                        cursor: "pointer",
                                        color: "#777",
                                        marginLeft: "5px",
                                        marginBottom: "4px",
                                      }}
                                    >
                                      ✏️
                                    </button>
                                  )}

                                  {/* {feature.name == "Featured Image"
                                    ? "Profile Image"
                                    : feature.name == "Company Logo"
                                    ? "Cover Image"
                                    : feature.name === "Reviews"
                                    ? "Site Reviews "
                                    : feature.name == "Video"
                                    ? "Video Embed"
                                    : feature.name == "Additional Details"
                                    ? "Additional Images"
                                    : feature.name}
                                </p> */}
                                </div>

                                {/* Toggle */}
                                <div>
                                  <Switch
                                    checked={feature.value}
                                    onChange={() => handleToggleFeature(index)}
                                  />
                                </div>
                              </div>
                            </div>
                          </>
                        ))}
                      </div>
                    </>
                  )}
                  {step === 3 && (
                    <>
                      <div className="text-left mb-4">
                        <div className="margin-top-10px">
                          <h2 className="text-black font-16">Trial period</h2>
                          <p className="font-15">
                            Enter the number of days for which a trial can be used.{" "}
                          </p>
                          <input
                            type="number"
                            className="margin-top-10px form-control-agust"
                            min="1"
                            max="100"
                            value={formData.trial_and_credit.days}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                trial_and_credit: {
                                  ...formData.trial_and_credit,
                                  days: e.target.value,
                                },
                              });
                            }}
                            style={{ width: "50%" }}
                          />
                        </div>
                      </div>
                    </>
                  )}

                  <div className="d-flex mt-6" style={{ justifyContent: "space-between" }}>
                    <button
                      className="savebtn-setting "
                      style={{ marginTop: "10px", width: "40%" }}
                      type="button"
                      onClick={() => handleCustomTab()}
                    >
                      Back
                    </button>

                    {step < 3 && (
                      <button
                        className="savebtn-setting"
                        style={{ marginTop: "10px", width: "40%" }}
                        type="button"
                        onClick={handleNext}
                      >
                        Next
                      </button>
                    )}
                    {step === 3 && (
                      <button
                        className="savebtn-setting "
                        style={{ marginTop: "10px", width: "40%" }}
                        onClick={handleFormSubmit}
                        disabled={loader}
                      >
                        {loader ? "Waiting..." : "Submit"}
                      </button>
                    )}
                  </div>
                </form>
              </div>
              <div
                className="d-flex  justify-content-between"
                style={{ width: "100%", marginTop: "15px", marginLeft: "15px" }}
              >
                <span className={step === 1 ? "color-active-new" : "color-inactive-new"}></span>

                <div
                  className={1 < step ? "color-active-border-new" : "color-inactive-border-new"}
                  style={{ width: "25%" }}
                ></div>
                <span className={step === 2 ? "color-active-new" : "color-inactive-new"}></span>

                <div
                  className={2 < step ? "color-active-border-new" : "color-inactive-border-new"}
                  style={{ width: "25%" }}
                ></div>
                <span className={step === 3 ? "color-active-new" : "color-inactive-new"}></span>
                <div
                  className={3 < step ? "color-active-border-new" : "color-inactive-border-new"}
                  style={{ width: "25%" }}
                ></div>

                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => handleCustomTab(4)}
                  className={step === 4 ? "color-active-new" : "color-inactive-new"}
                ></span>
              </div>
            </div>
          </div>
        </div>

        {addCategoryModel && (
          <div className="modal-zz-confirm text-left">
            <div
              className="scrollable-modal-content bg-white rounded"
              style={{ position: "relative" }}
            >
              <h2 className="text-black text-left font-14" style={{ marginBottom: "10px" }}>
                Add New Category
              </h2>
              <span className="crossison" onClick={() => setAddCategoryModel(false)}>
                X
              </span>
              <input
                type="text"
                id="category"
                className="form-control-agust w-full"
                name="category"
                placeholder={"Enter Category Name "}
                value={categoryFormData.category}
                onChange={(e) =>
                  setCategoryFormData({
                    ...categoryFormData,
                    name: e.target.value,
                  })
                }
              />
              <div style={{ margin: "10px 0px" }}>
                <ReactSelect
                  className="form-input w-full"
                  options={availableCRNC}
                  isMulti={false}
                  onChange={Change_of_currency}
                  menuPortalTarget={document.body} // Render dropdown outside the modal
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Set z-index for visibility
                  }}
                />
              </div>
              <div className="w-100 margin-top-20px">
                <button type="submit" className="btn-newdezine" onClick={savecategory}>
                  Save
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      {editIndex !== null && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 999,
          }}
        >
          <div style={{ background: "#fff", padding: 20, borderRadius: 8, width: 450 }}>
            <h5>Rename Feature</h5>

            <input
              type="text"
              className="form-control"
              style={{width:"100%",padding:"10px",marginTop:"10px",border:"1px solid #ccc",borderRadius:"4px"}}
              value={editValue}
              onChange={(e) => setEditValue(e.target.value)}
            />

             <div className="d-flex mt-6" style={{ justifyContent: "space-between" }}>
              <button className="savebtn-setting" style={{ marginTop: "10px", width: "40%" }} onClick={() => setEditIndex(null)}>
                Cancel
              </button>
              <button
                className="savebtn-setting"
                style={{ marginTop: "10px", width: "40%" }}
                onClick={() => {
                  handleRenameFeature(editIndex, editValue);
                  setEditIndex(null);
                }}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MultistepFormWizard;
